import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import { useStore } from '../services/store.service';
import { useNotifications } from '@/services/notifications.service';
const { showError } = useNotifications();
import { User } from '../types/api.types';


declare module 'vue-router' {
  interface RouteMeta {
    roles: string[];
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      roles: [],
    },
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ '../views/UsersView.vue'),
    meta: {
      roles: ['user', 'moderator', 'admin'],
    },
  },
  {
    path: '/system',
    name: 'system',
    component: () => import(/* webpackChunkName: "system" */ '../views/SystemView.vue'),
    meta: {
      roles: ['admin'],
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue'),
    meta: {
      roles: []
    },
  },
  {
    path: '/reset-password-link',
    name: 'reset-password-link',
    component: () => import(/* webpackChunkName: "reset-password-link" */ '../views/ResetPasswordLinkView.vue'),
    meta: { 
      roles: [],
     },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import(/* webpackChunkName: "reset-password" */ '../views/ResetPasswordView.vue'),
    meta: {
      roles: [],
    },
  },
  {
    path: '/profile',
    name: 'profile',
    // route level code-splitting
    // this generates a separate chunk (profile.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "profile" */ '../views/ProfileView.vue'),
    meta: {
      roles: ['user', 'moderator', 'admin']
    },
  },
  {
    path: '/error:code(\\d+)',
    name: 'Error',
    component: () => import('../views/ErrorView.vue'),
    props: route => ({ code: Number(route.params.code) }),
    meta: {
      roles: []
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard for authentication

router.beforeEach(async (to, from, next) => {
  const store = useStore();

  // Wait for app to be ready (user loaded)
  if (!store.isAppReady()) {
    await new Promise<void>(resolve => {
      const check = () => {
        if (store.isAppReady()) {
          resolve();
        } else {
          setTimeout(check, 10);
        }
      };
      check();
    });
  }
  // Role-based access control
  const routeRoles = to.meta.roles;
  const user = store.getData('user') as User || {};
  const userRole = user.role || null;
  const isAuthenticated = store.isAuthenticated() || false;

  if (routeRoles && routeRoles.length > 0) {
    if (!isAuthenticated) {
      next({ name: 'login' });
      return;
    }
    if (!userRole || !routeRoles.includes(userRole)) {
      showError('Access denied: User role not permitted');
      next({ name: 'Error', params: { code: 403 } });
      return;
    }
  }

  if (!to.matched.length) {
    // No matching route, redirect to error page
    next({ name: 'Error', params: { code: 404 } });
  } else {
    next();
  }
});

export default router;
